import { useRef } from "react";
import { useNavigate } from "react-router-dom";
import { routeNames } from "../../../constants/routes";
import { AppDispatch } from "../../../redux/store";
import { useDispatch, useSelector } from "react-redux";
import { loginUser } from "../../../redux/slices/authSlice";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { RootState } from "../../../redux/store";
import { toast } from "react-hot-toast";
import { loginSchema } from "../../../constants/yup.schema";

export default function useLogin() {
  const navigate = useNavigate();
  const dispatch: AppDispatch = useDispatch();

  const { error } = useSelector((state: RootState) => state.auth);

  const {
    control,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(loginSchema),
    defaultValues: {
      username: "",
      password: "",
    },
  });

  const defaultValues = useRef({
    username: "",
    password: "",
  });

  const methods = useForm({
    defaultValues: defaultValues.current,
    resolver: yupResolver(loginSchema),
  });
  const {
    handleSubmit,
    formState: { isSubmitting },
  } = methods;

  const onSubmit = async (formData: { username: string; password: string }) => {
    const result = await dispatch(loginUser(formData));
    if (loginUser.fulfilled.match(result)) {
      toast.success("Login Successful");
      navigate(routeNames.dashboardHome);
    } else {
      toast.error("Login Failed");
    }
  };
  return {
    error,
    control,
    errors,
    handleSubmit,
    isSubmitting,
    onSubmit,
    methods,
  };
}
